import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  contactsTitle: {
    display: "flex",
    flexDirection: "column"
  },
  infoTitle: {
    marginTop: "2px",
    marginBottom: "6px"
  },
  subtitle: {
    margin: "13px 0 0px"
  }
});
